
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationU as ObiLocationUElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-u.js';
 
 
 

 
 export const ObiLocationU = createComponent({
   react: React,
   tagName: 'obi-location-u',
   elementClass: ObiLocationUElement,
   events: {
     
   }
  });
 
 